export type CrewStatus = "active" | "off" | "on-leave" | "training";

export type CrewMember = {
  id: string;
  name: string;
  initials: string;
  color: string;
  role: string;
  email: string;
  phone: string;
  hireDate: string;
  rating: number;
  completedMoves: number;
  hourlyRate: number;
  weeklyHours: number;
  weeklyTarget: number;
  status: CrewStatus;
  currentProject?: string;
  clockedInAt?: string;
  skills: string[];
  availability: ("M" | "T" | "W" | "Th" | "F" | "Sa" | "Su")[];
  city: string;
  accessToken?: string;
};

export const crewMembers: CrewMember[] = [
  {
    id: "C-101",
    name: "Marcus Reed",
    initials: "MR",
    color: "bg-brand-500",
    role: "Lead Mover",
    email: "marcus.reed@haulmark.co",
    phone: "(512) 555-0211",
    hireDate: "Feb 2022",
    rating: 4.9,
    completedMoves: 318,
    hourlyRate: 32,
    weeklyHours: 34,
    weeklyTarget: 40,
    status: "active",
    currentProject: "MV-2041",
    clockedInAt: "07:24",
    skills: ["Piano", "Antiques", "CDL-C", "Lead"],
    availability: ["M", "T", "W", "Th", "F"],
    city: "Austin, TX",
  },
  {
    id: "C-102",
    name: "Diego Alvarez",
    initials: "DA",
    color: "bg-emerald-500",
    role: "Mover / Driver",
    email: "diego.alvarez@haulmark.co",
    phone: "(512) 555-0218",
    hireDate: "Aug 2022",
    rating: 4.8,
    completedMoves: 264,
    hourlyRate: 28,
    weeklyHours: 32,
    weeklyTarget: 40,
    status: "active",
    currentProject: "MV-2041",
    clockedInAt: "07:28",
    skills: ["CDL-B", "Driver", "Packing"],
    availability: ["M", "T", "W", "Th", "F", "Sa"],
    city: "Austin, TX",
  },
  {
    id: "C-103",
    name: "Tyler Brooks",
    initials: "TB",
    color: "bg-amber-500",
    role: "Mover",
    email: "tyler.brooks@haulmark.co",
    phone: "(512) 555-0223",
    hireDate: "Mar 2023",
    rating: 4.7,
    completedMoves: 142,
    hourlyRate: 24,
    weeklyHours: 28,
    weeklyTarget: 40,
    status: "active",
    currentProject: "MV-2041",
    clockedInAt: "07:30",
    skills: ["Packing", "Heavy lift"],
    availability: ["T", "W", "Th", "F", "Sa", "Su"],
    city: "Round Rock, TX",
  },
  {
    id: "C-104",
    name: "Samira Khan",
    initials: "SK",
    color: "bg-indigo-500",
    role: "Lead Mover",
    email: "samira.khan@haulmark.co",
    phone: "(512) 555-0231",
    hireDate: "Jun 2021",
    rating: 4.9,
    completedMoves: 412,
    hourlyRate: 34,
    weeklyHours: 38,
    weeklyTarget: 40,
    status: "active",
    currentProject: "MV-2042",
    clockedInAt: "08:55",
    skills: ["Commercial", "Office", "Lead", "Packing"],
    availability: ["M", "T", "W", "Th", "F"],
    city: "Austin, TX",
  },
  {
    id: "C-105",
    name: "Aaron Mills",
    initials: "AM",
    color: "bg-rose-500",
    role: "Mover",
    email: "aaron.mills@haulmark.co",
    phone: "(512) 555-0245",
    hireDate: "Jan 2024",
    rating: 4.6,
    completedMoves: 98,
    hourlyRate: 22,
    weeklyHours: 30,
    weeklyTarget: 40,
    status: "active",
    currentProject: "MV-2042",
    clockedInAt: "08:58",
    skills: ["Packing", "Heavy lift"],
    availability: ["M", "T", "W", "Th", "F", "Sa"],
    city: "Austin, TX",
  },
  {
    id: "C-106",
    name: "Caleb Thompson",
    initials: "CT",
    color: "bg-teal-500",
    role: "Mover",
    email: "caleb.thompson@haulmark.co",
    phone: "(512) 555-0258",
    hireDate: "Sep 2023",
    rating: 4.7,
    completedMoves: 124,
    hourlyRate: 24,
    weeklyHours: 26,
    weeklyTarget: 40,
    status: "active",
    currentProject: "MV-2042",
    clockedInAt: "09:02",
    skills: ["Packing", "Electronics"],
    availability: ["M", "W", "Th", "F", "Sa", "Su"],
    city: "Cedar Park, TX",
  },
  {
    id: "C-107",
    name: "Jordan Pierce",
    initials: "JP",
    color: "bg-orange-500",
    role: "Driver",
    email: "jordan.pierce@haulmark.co",
    phone: "(512) 555-0269",
    hireDate: "Mar 2022",
    rating: 4.8,
    completedMoves: 281,
    hourlyRate: 30,
    weeklyHours: 36,
    weeklyTarget: 40,
    status: "active",
    currentProject: "MV-2042",
    clockedInAt: "09:00",
    skills: ["CDL-A", "Long Distance", "Driver"],
    availability: ["M", "T", "W", "Th", "F"],
    city: "Pflugerville, TX",
  },
  {
    id: "C-108",
    name: "Wes Holloway",
    initials: "WH",
    color: "bg-amber-600",
    role: "Lead Mover",
    email: "wes.holloway@haulmark.co",
    phone: "(512) 555-0274",
    hireDate: "Nov 2020",
    rating: 4.8,
    completedMoves: 487,
    hourlyRate: 33,
    weeklyHours: 0,
    weeklyTarget: 40,
    status: "active",
    skills: ["Lead", "Antiques", "Piano"],
    availability: ["T", "W", "Th", "F", "Sa"],
    city: "Austin, TX",
  },
  {
    id: "C-109",
    name: "Nina Castro",
    initials: "NC",
    color: "bg-pink-500",
    role: "Mover",
    email: "nina.castro@haulmark.co",
    phone: "(512) 555-0282",
    hireDate: "Apr 2023",
    rating: 4.7,
    completedMoves: 132,
    hourlyRate: 24,
    weeklyHours: 8,
    weeklyTarget: 32,
    status: "active",
    skills: ["Packing", "Inventory"],
    availability: ["W", "Th", "F", "Sa", "Su"],
    city: "Austin, TX",
  },
  {
    id: "C-110",
    name: "Owen Patel",
    initials: "OP",
    color: "bg-cyan-600",
    role: "Driver",
    email: "owen.patel@haulmark.co",
    phone: "(512) 555-0291",
    hireDate: "Jul 2022",
    rating: 4.8,
    completedMoves: 218,
    hourlyRate: 30,
    weeklyHours: 12,
    weeklyTarget: 40,
    status: "active",
    skills: ["CDL-B", "Driver"],
    availability: ["M", "T", "Th", "F", "Sa"],
    city: "Leander, TX",
  },
  {
    id: "C-111",
    name: "Damon Frye",
    initials: "DF",
    color: "bg-emerald-600",
    role: "Mover",
    email: "damon.frye@haulmark.co",
    phone: "(512) 555-0302",
    hireDate: "Oct 2023",
    rating: 4.5,
    completedMoves: 87,
    hourlyRate: 22,
    weeklyHours: 0,
    weeklyTarget: 40,
    status: "off",
    skills: ["Heavy lift", "Packing"],
    availability: ["M", "T", "W", "Th", "F"],
    city: "Cedar Park, TX",
  },
  {
    id: "C-112",
    name: "Ronnie Vega",
    initials: "RV",
    color: "bg-brand-600",
    role: "Mover",
    email: "ronnie.vega@haulmark.co",
    phone: "(512) 555-0315",
    hireDate: "May 2023",
    rating: 4.6,
    completedMoves: 118,
    hourlyRate: 23,
    weeklyHours: 22,
    weeklyTarget: 40,
    status: "active",
    skills: ["Packing", "Inventory"],
    availability: ["M", "T", "W", "F", "Sa"],
    city: "Round Rock, TX",
  },
  {
    id: "C-113",
    name: "Kenji Yamada",
    initials: "KY",
    color: "bg-fuchsia-500",
    role: "Lead Mover",
    email: "kenji.yamada@haulmark.co",
    phone: "(512) 555-0327",
    hireDate: "Aug 2021",
    rating: 4.9,
    completedMoves: 376,
    hourlyRate: 33,
    weeklyHours: 28,
    weeklyTarget: 40,
    status: "active",
    skills: ["Lead", "Long Distance", "Antiques"],
    availability: ["M", "T", "W", "Th", "F", "Sa"],
    city: "Austin, TX",
  },
  {
    id: "C-114",
    name: "Hector Solano",
    initials: "HS",
    color: "bg-amber-500",
    role: "Mover",
    email: "hector.solano@haulmark.co",
    phone: "(512) 555-0339",
    hireDate: "Feb 2024",
    rating: 4.5,
    completedMoves: 64,
    hourlyRate: 22,
    weeklyHours: 18,
    weeklyTarget: 40,
    status: "active",
    skills: ["Packing"],
    availability: ["M", "W", "Th", "Sa", "Su"],
    city: "San Marcos, TX",
  },
  {
    id: "C-115",
    name: "Briggs Cole",
    initials: "BC",
    color: "bg-rose-600",
    role: "Mover",
    email: "briggs.cole@haulmark.co",
    phone: "(512) 555-0344",
    hireDate: "Jun 2024",
    rating: 4.4,
    completedMoves: 38,
    hourlyRate: 21,
    weeklyHours: 14,
    weeklyTarget: 32,
    status: "training",
    skills: ["Packing", "Trainee"],
    availability: ["M", "T", "W", "Th", "F"],
    city: "Austin, TX",
  },
  {
    id: "C-116",
    name: "Levi Brooks",
    initials: "LB",
    color: "bg-teal-600",
    role: "Mover",
    email: "levi.brooks@haulmark.co",
    phone: "(512) 555-0356",
    hireDate: "Dec 2022",
    rating: 4.7,
    completedMoves: 178,
    hourlyRate: 25,
    weeklyHours: 0,
    weeklyTarget: 40,
    status: "on-leave",
    skills: ["Packing", "Heavy lift"],
    availability: [],
    city: "Round Rock, TX",
  },
];

export type ShiftEntry = {
  id: string;
  crewId: string;
  crewName: string;
  initials: string;
  color: string;
  role: string;
  projectId: string;
  clockIn: string;
  clockOut: string | null;
  break: number; // minutes
  totalHours: number | null;
  status: "active" | "on-break" | "completed" | "pending-approval";
  hourlyRate: number;
};

export const todayShifts: ShiftEntry[] = [
  {
    id: "S-9001",
    crewId: "C-101",
    crewName: "Marcus Reed",
    initials: "MR",
    color: "bg-brand-500",
    role: "Lead Mover",
    projectId: "MV-2041",
    clockIn: "07:24",
    clockOut: null,
    break: 0,
    totalHours: null,
    status: "active",
    hourlyRate: 32,
  },
  {
    id: "S-9002",
    crewId: "C-102",
    crewName: "Diego Alvarez",
    initials: "DA",
    color: "bg-emerald-500",
    role: "Mover / Driver",
    projectId: "MV-2041",
    clockIn: "07:28",
    clockOut: null,
    break: 0,
    totalHours: null,
    status: "active",
    hourlyRate: 28,
  },
  {
    id: "S-9003",
    crewId: "C-103",
    crewName: "Tyler Brooks",
    initials: "TB",
    color: "bg-amber-500",
    role: "Mover",
    projectId: "MV-2041",
    clockIn: "07:30",
    clockOut: null,
    break: 15,
    totalHours: null,
    status: "on-break",
    hourlyRate: 24,
  },
  {
    id: "S-9004",
    crewId: "C-104",
    crewName: "Samira Khan",
    initials: "SK",
    color: "bg-indigo-500",
    role: "Lead Mover",
    projectId: "MV-2042",
    clockIn: "08:55",
    clockOut: null,
    break: 0,
    totalHours: null,
    status: "active",
    hourlyRate: 34,
  },
  {
    id: "S-9005",
    crewId: "C-105",
    crewName: "Aaron Mills",
    initials: "AM",
    color: "bg-rose-500",
    role: "Mover",
    projectId: "MV-2042",
    clockIn: "08:58",
    clockOut: null,
    break: 0,
    totalHours: null,
    status: "active",
    hourlyRate: 22,
  },
  {
    id: "S-9006",
    crewId: "C-106",
    crewName: "Caleb Thompson",
    initials: "CT",
    color: "bg-teal-500",
    role: "Mover",
    projectId: "MV-2042",
    clockIn: "09:02",
    clockOut: null,
    break: 0,
    totalHours: null,
    status: "active",
    hourlyRate: 24,
  },
  {
    id: "S-9007",
    crewId: "C-107",
    crewName: "Jordan Pierce",
    initials: "JP",
    color: "bg-orange-500",
    role: "Driver",
    projectId: "MV-2042",
    clockIn: "09:00",
    clockOut: null,
    break: 30,
    totalHours: null,
    status: "active",
    hourlyRate: 30,
  },
];

export type PendingApproval = {
  id: string;
  crewId: string;
  crewName: string;
  initials: string;
  color: string;
  projectId: string;
  date: string;
  clockIn: string;
  clockOut: string;
  hours: number;
  flag?: string;
};

export const pendingApprovals: PendingApproval[] = [
  {
    id: "PA-401",
    crewId: "C-104",
    crewName: "Samira Khan",
    initials: "SK",
    color: "bg-indigo-500",
    projectId: "MV-2038",
    date: "May 31",
    clockIn: "07:55",
    clockOut: "17:42",
    hours: 9.78,
    flag: "Overtime",
  },
  {
    id: "PA-402",
    crewId: "C-103",
    crewName: "Tyler Brooks",
    initials: "TB",
    color: "bg-amber-500",
    projectId: "MV-2038",
    date: "May 31",
    clockIn: "07:58",
    clockOut: "17:42",
    hours: 9.73,
    flag: "Overtime",
  },
  {
    id: "PA-403",
    crewId: "C-105",
    crewName: "Aaron Mills",
    initials: "AM",
    color: "bg-rose-500",
    projectId: "MV-2039",
    date: "May 31",
    clockIn: "08:35",
    clockOut: "14:10",
    hours: 5.58,
  },
  {
    id: "PA-404",
    crewId: "C-110",
    crewName: "Owen Patel",
    initials: "OP",
    color: "bg-cyan-600",
    projectId: "MV-2037",
    date: "May 30",
    clockIn: "10:12",
    clockOut: "15:48",
    hours: 5.6,
    flag: "Missed punch-in",
  },
];

export type WeeklySummary = {
  crewId: string;
  name: string;
  initials: string;
  color: string;
  role: string;
  hours: number;
  regularHours: number;
  otHours: number;
  pay: number;
  shifts: number;
};

export const weeklyTimesheets: WeeklySummary[] = [
  {
    crewId: "C-104",
    name: "Samira Khan",
    initials: "SK",
    color: "bg-indigo-500",
    role: "Lead Mover",
    hours: 42.4,
    regularHours: 40,
    otHours: 2.4,
    pay: 1482,
    shifts: 5,
  },
  {
    crewId: "C-101",
    name: "Marcus Reed",
    initials: "MR",
    color: "bg-brand-500",
    role: "Lead Mover",
    hours: 38.2,
    regularHours: 38.2,
    otHours: 0,
    pay: 1222,
    shifts: 5,
  },
  {
    crewId: "C-107",
    name: "Jordan Pierce",
    initials: "JP",
    color: "bg-orange-500",
    role: "Driver",
    hours: 36.5,
    regularHours: 36.5,
    otHours: 0,
    pay: 1095,
    shifts: 5,
  },
  {
    crewId: "C-113",
    name: "Kenji Yamada",
    initials: "KY",
    color: "bg-fuchsia-500",
    role: "Lead Mover",
    hours: 34.0,
    regularHours: 34.0,
    otHours: 0,
    pay: 1122,
    shifts: 4,
  },
  {
    crewId: "C-102",
    name: "Diego Alvarez",
    initials: "DA",
    color: "bg-emerald-500",
    role: "Mover / Driver",
    hours: 32.0,
    regularHours: 32.0,
    otHours: 0,
    pay: 896,
    shifts: 4,
  },
  {
    crewId: "C-106",
    name: "Caleb Thompson",
    initials: "CT",
    color: "bg-teal-500",
    role: "Mover",
    hours: 28.5,
    regularHours: 28.5,
    otHours: 0,
    pay: 684,
    shifts: 4,
  },
  {
    crewId: "C-103",
    name: "Tyler Brooks",
    initials: "TB",
    color: "bg-amber-500",
    role: "Mover",
    hours: 28.0,
    regularHours: 28.0,
    otHours: 0,
    pay: 672,
    shifts: 4,
  },
  {
    crewId: "C-105",
    name: "Aaron Mills",
    initials: "AM",
    color: "bg-rose-500",
    role: "Mover",
    hours: 26.0,
    regularHours: 26.0,
    otHours: 0,
    pay: 572,
    shifts: 4,
  },
];

export type RecentShift = {
  date: string;
  project: string;
  hours: number;
  clockIn: string;
  clockOut: string;
  role: string;
};

export const memberRecentShifts: Record<string, RecentShift[]> = {
  default: [
    {
      date: "Jun 01",
      project: "MV-2041",
      hours: 0,
      clockIn: "07:24",
      clockOut: "—",
      role: "Lead Mover",
    },
    {
      date: "May 31",
      project: "MV-2039",
      hours: 6.5,
      clockIn: "08:55",
      clockOut: "15:25",
      role: "Lead Mover",
    },
    {
      date: "May 30",
      project: "MV-2038",
      hours: 8.2,
      clockIn: "08:00",
      clockOut: "16:12",
      role: "Lead Mover",
    },
    {
      date: "May 29",
      project: "MV-2037",
      hours: 4.8,
      clockIn: "11:00",
      clockOut: "15:48",
      role: "Lead Mover",
    },
    {
      date: "May 28",
      project: "MV-2035",
      hours: 9.4,
      clockIn: "07:45",
      clockOut: "17:09",
      role: "Lead Mover",
    },
    {
      date: "May 27",
      project: "MV-2034",
      hours: 7.1,
      clockIn: "08:30",
      clockOut: "15:36",
      role: "Lead Mover",
    },
  ],
};

// Quick stats for whole crew page
export const crewStats = [
  {
    label: "Total Crew",
    value: "38",
    sub: "5 leads · 11 drivers",
    icon: "ri-team-line",
    color: "text-indigo-600 bg-indigo-50",
  },
  {
    label: "On The Clock",
    value: "7",
    sub: "spread across 2 jobs",
    icon: "ri-time-line",
    color: "text-brand-600 bg-brand-50",
  },
  {
    label: "Hours This Week",
    value: "1,284",
    sub: "+8.4% vs last week",
    icon: "ri-bar-chart-2-line",
    color: "text-emerald-600 bg-emerald-50",
  },
  {
    label: "Weekly Payroll",
    value: "$31,420",
    sub: "as of today",
    icon: "ri-money-dollar-circle-line",
    color: "text-amber-600 bg-amber-50",
  },
];